export default {
  select: {
    '&:focus': {
      backgroundColor: '#fff',
      borderRadius: 4
    }
  }
}
